const API_BASE = '/api/v1/public/projects';
const VSJ_SLUG = 'valor-san-juan';

export type PlaceReadStatus = 'available' | 'insufficient_data';

export interface PlaceReadingDto {
  status: PlaceReadStatus;
  streetTypeLabel: string;
  roadClass: string | null;
  observationCount: number;
  radiusM: number;
  periodLabel: string;
  observedTypes: string[];
}

export async function fetchPlaceReading(token: string): Promise<PlaceReadingDto> {
  const res = await fetch(
    `${API_BASE}/${VSJ_SLUG}/places/read?token=${encodeURIComponent(token)}`,
  );
  if (!res.ok) throw new Error(`place-read: HTTP ${res.status}`);
  return res.json() as Promise<PlaceReadingDto>;
}
